export default {
  methods: {
    onlyLatinFormatter(value) {
      // remove arabic text
      return value.replace(/[\u0600-\u06FF]|[а-яА-ЯЁё]/gi, '')
    },
    onlyLatinAndNumbersFormatter(value) {
      return value.replace(/[^a-z0-9]/gi, '')
    },
    onlyNumbersFormatter(value) {
      return value.replace(/[^0-9]/gi, '')
    }
  }
}
